import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import ArticleCards from "./components/ArticleCards";
import FeaturesSection from "./components/FeaturesSection";
import BrandSection from "./components/BrandSection";
import SeoContentSections from "./components/SeoContentSections";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <SeoContentSections />
        <CategoryGrid />
        <CTASection />
        <ArticleCards />
        <FeaturesSection />
        <BrandSection />
      </main>
      <Footer />
    </div>
  );
}